import React from 'react';
import { isFeatureApp, isContentContainerWithContent, } from '../content-types';
import { UeContainer, UeReference } from '../universal-editor';
import { UeContainerProvider } from '../universal-editor/context/container-context';
import { FeatureApp } from './feature-app';
import { fetchContent } from './fetch';
import { getLoadableContentPaths, isContainerError } from './utils';
import { useContentContainerState } from './context';
function createId(prefix, appId, indices) {
    return `${prefix}${appId}-${indices.join('-')}`;
}
export const Spawn = (props) => {
    const { featureApps, idPrefix, with: FeatureAppComponent = FeatureApp, propertyPath, label, renderOnError, designSystem, logger = console, } = props;
    const isContentArray = Array.isArray(featureApps);
    const items = React.useMemo(() => (isContentArray ? featureApps : [featureApps]), [featureApps]);
    const { state: containerContent, update, batchUpdate, } = useContentContainerState();
    React.useEffect(() => {
        const { contentApiConfig } = props;
        const missingContainers = getLoadableContentPaths(items, containerContent);
        if (missingContainers.length && !contentApiConfig) {
            throw new Error(`Cannot render content containers without API config`);
        }
        batchUpdate(Object.fromEntries(missingContainers.map((contentPath) => [contentPath, 'LOADING'])));
        missingContainers.forEach(async (contentPath) => {
            try {
                const content = await fetchContent(contentPath, contentApiConfig, logger, idPrefix);
                update(contentPath, content);
            }
            catch (error) {
                update(contentPath, error);
            }
        });
    }, [items]);
    const content = (React.createElement(React.Fragment, null, items.flatMap((item, index) => {
        const contentPath = typeof item === 'string' ? item : item.contentPath;
        const property = propertyPath?.split('.').pop();
        if (isFeatureApp(item)) {
            const id = createId(idPrefix, item.model.metadata.id, [index]);
            return propertyPath ? (React.createElement(UeReference, { key: id, label: item.model.title, propertyPath: isContentArray ? `${propertyPath}.${index}` : propertyPath, behavior: "component", as: "div" },
                React.createElement(FeatureAppComponent, { app: item, id: id, designSystem: designSystem, logger: logger }))) : (React.createElement(FeatureAppComponent, { key: id, app: item, id: id, designSystem: designSystem, logger: logger }));
        }
        const container = isContentContainerWithContent(item)
            ? item
            : containerContent[contentPath];
        switch (container) {
            case undefined:
            case 'LOADING':
                return (React.createElement(React.Fragment, { key: contentPath }, props.loader || null));
            default: {
                if (isContainerError(container)) {
                    return renderOnError ? renderOnError(container) : null;
                }
                const containerItems = Object.entries(container.fields)
                    .filter(([field]) => field.endsWith('Content'))
                    .flatMap(([field, nestedContent]) => {
                    if (!nestedContent) {
                        return null;
                    }
                    return (React.createElement(Spawn, { key: `${container.contentPath}|${field}`, featureApps: nestedContent, idPrefix: `${idPrefix}${index}-`, designSystem: designSystem, logger: logger, with: FeatureAppComponent, label: property, propertyPath: propertyPath
                            ? `${propertyPath}.${isContentArray ? `${index}.` : ''}${field}`
                            : undefined }));
                });
                return propertyPath ? (React.createElement(UeContainerProvider, { key: container.contentPath, value: {
                        container,
                        propertyPath: isContentArray
                            ? `${propertyPath}.${index}`
                            : `${propertyPath}`,
                    } },
                    React.createElement(UeReference, { propertyPath: isContentArray
                            ? `${propertyPath}.${index}`
                            : `${propertyPath}`, behavior: "component", as: "div" }, containerItems))) : (containerItems);
            }
        }
    })));
    return propertyPath ? (React.createElement(UeContainer, { label: label, propertyPath: propertyPath }, content)) : (content);
};
Spawn.displayName = 'Spawn';
//# sourceMappingURL=component.js.map